<template>
  <div class="meal_selector">
    <div class="loading" v-if="loading">
      <i class="pi pi-spin pi-spinner" style="fontsize: 2rem"></i>
    </div>
    <div v-else>
      <span v-if="order.open">
        <span v-if="!order.complete">
          <span v-if="meals.length > 0">
            <div
              @click="openMeal(m.id)"
              class="meal"
              v-for="(m,index ) in meals"
              :key="m.id + index"
            >
              <div
                class="image"
                :style="'background-image: url(' + m.url + ');'"
              ></div>
              <div>
                <div class="title">{{ m.title }}</div>
                <div class="desc">
                  {{
                    m.desc.length > 60
                      ? m.desc.substring(0, 60).trim() + "..."
                      : m.desc
                  }}
                </div>
              </div>
              <div class="selector">
                <svg viewBox="0 0 24 24">
                  <path
                    fill="currentColor"
                    d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z"
                  />
                </svg>
              </div>
            </div>
          </span>
          <span v-else> No meals found. </span>
        </span>
        <span v-else>
          <meal-ordered :meal="order.type" />
        </span>
      </span>
      <span v-else>
      This meal is closed for the day.
    </span>
    </div>
  </div>
</template>

<script>
import { fb_db } from "../firebase";
import MealOrdered from "@/components/MealOrdered.vue";
import { mapState } from 'vuex'

export default {
  name: "MealSelector",
  components: {
    MealOrdered,
  },
  data() {
    return {
      loading: true,
      meals: [],
      menu: {},
      closed: false,
    };
  },
  async mounted() {
    console.log("MealSelector Mounted", this.order);
    if (this.dayinmenu) {
      this.getMeals()
    }
  },
  methods: {
    async getMeals() {
      this.loading = true;
      this.meals = [];
      console.log("getting meals", this.dayinmenu);
      const doc = await fb_db.collection("menu").doc(this.dayinmenu.toString()).get();
      this.menu = doc.data()

      this.menu[this.mealType].forEach(async m => {
        let item = await m.get()
        this.meals.push( Object.assign({id: item.id},item.data()) )
      });
      setTimeout(() => {
        this.loading = false;
      }, 300);
    },
    openMeal(id) {
      this.$router.push(this.mealType + "/" + id);
    },
  },
  computed: {
    ...mapState([
      'dayinmenu',
      'day',
      'week',
    ]),
    mealType() {
      return this.$route.name.toLowerCase();
    },
    order() {
      return this.$store.state.orders[this.mealType];
    },
  },
  watch: {
    dayinmenu(newValue, oldValue) {
      this.getMeals()
    }
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/theme.scss";

.meal_selector {
  width: 100%;
  background: $white;
  //border-radius: 25px 0px 0px 0px;
  color: $text;
  height: calc(100% - 94px);
  position: absolute;
  top: 94px;

  .meal {
    display: flex;
    text-align: left;
    cursor: pointer;

    .image {
      width: 150px;
      height: 150px;
      background-color: #efefef;
      margin-right: 15px;
      background-size: cover;
      background-position: center;
    }

    .title {
      font-size: 18px;
      margin-bottom: 5px;
      width: 50vw;
      margin-top: 15px;
    }

    .desc {
      font-size: 14px;
      width: 110px;
      width: 42vw;
    }

    .selector {
      height: 100px;
      width: 25px;

      svg {
        height: 40px;
        margin-top: 25px;
      }
    }
  }
}
</style>